import { useEffect } from "react";
import { useAppSelector, useResponsive } from "@/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { Paper, Stack, Typography } from "@mui/material";
import { isLoggedInSelector } from "@/features/auth/slice";
import SignInForm from "./SignInForm";
import routes from "@/constants/routes";
import Logo from "@/assets/logos/bitelink-logo-blue-bg.svg";

const SignInPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const { isMobile, isTablet } = useResponsive();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(state?.prevPage ?? routes.organizations.main, { replace: true });
    }
  }, [isLoggedIn, navigate, state?.prevPage]);

  return (
    <Stack direction={{ xs: "column", lg: "row" }} minHeight="100vh">
      <Stack
        flex={{ xs: 1, lg: 3 }}
        alignItems="center"
        justifyContent="center"
        paddingY={6}
        paddingX={2}
        paddingBottom={"200px"}
        spacing={3}
        sx={{
          background: "linear-gradient(139deg, #015FEE 42.76%, #D0F857 94.31%)",
        }}
      >
        <img src={Logo} alt="Bitelink logo" style={{ cursor: "pointer" }} onClick={() => (window.location.href = "https://bitelink.website")} />
        <Paper
          sx={{
            minWidth: isMobile ? "auto" : 350,
            padding: isMobile ? 3 : 6,
            borderRadius: 6,
          }}
        >
          <SignInForm />
        </Paper>
        <Typography variant="body2" color="white">
          No tienes una cuenta?{" "}
          <a href="/sign-up" style={{ color: "white" }}>
            Crear cuenta
          </a>
        </Typography>
      </Stack>

      <Stack
        sx={{
          background: "white",
        }}
        justifyContent={{ lg: "flex-end" }}
        alignItems={"flex-start"}
      >
        <img
          src="https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2Fclient-user.webp?alt=media&token=49654690-02ad-444c-b2e6-f6020bc3ded5"
          alt="login platform illustration"
          style={{
            width: isMobile ? "80%" : "700px",
            marginLeft: isMobile || isTablet ? "auto" : "-300px",
            marginRight: "auto",
            marginTop: isMobile || isTablet ? "-175px" : 0,
          }}
        />
      </Stack>
    </Stack>
  );
};

export default SignInPage;
